<template>
  <div class="filter-container">
    <div
      v-if="
        selectedFilter == null || selectedFilter.value != searchMode.Advanced
      "
      class="row"
    >
      <div class="col-md-3 col-lg-3 col-sm-6 py-1">
        <custom-dropdown
          v-model="selectedAcademicYear"
          placeholder="Seleccione el año"
          fieldkey="value"
          fieldname="name"
          :options="academicyears"
          @input="resetFilters"
        />
      </div>
      <div class="col-md-6 col-lg-6 col-sm-6 py-1">
        <custom-input
          id="searchText"
          v-model="searchText"
          :placeholder="searchTextPlaceholder"
          left-icon
          icon="fa fa-search orange-icon"
        />
      </div>
      <div class="col-md-3 col-lg-3 col-sm-12 py-1">
        <action-button
          text="Buscar"
          i="fa fa-search"
          variant="success"
          class="fr ml-4 px-4 mb-2"
          @click="onSearch"
        />
        <action-button
          v-if="!simple"
          i="fal fa-sliders-v"
          variant="orange"
          class="fr mr-2 pl-3"
          :class="{ transparent: !isAdvancedFilter }"
          @click="onPressAdvancedFilter"
        />
      </div>
    </div>

    <div
      v-if="isAdvancedFilter && selectedFilter.value == searchMode.Advanced"
      class="row"
    >
      <div class="col-12 col-sm-6 col-md-2 py-1">
        <custom-dropdown
          v-model="selectedAcademicYear"
          placeholder="Seleccione el año"
          fieldkey="value"
          fieldname="name"
          :options="academicyears"
          @input="resetFilters"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-2 py-1">
        <!--v-model="selectedMonth"  -->
        <ValidationProvider
          ref="months"
          v-slot="{ errors }"
          :rules="
            `${
              this.isFiltering != null &&
              this.isReferralFiltering != null &&
              !this.isFiltering &&
              !this.isReferralFiltering
                ? 'required'
                : ''
            }`
          "
          name="Mes"
          inmediate
        >
          <custom-dropdown
            v-model="selectedMonth"
            placeholder="Seleccione el mes"
            fieldkey="value"
            fieldname="name"
            :options="months"
            :error="errors[0]"
            custom-error-msg="Al menos el mes se debe seleccionar"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-sm-6 col-md-5 py-1">
        <custom-input
          id="searchText"
          v-model="searchText"
          :placeholder="searchTextPlaceholder"
          left-icon
          icon="fa fa-search orange-icon"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-3 py-1">
        <action-button
          text="Buscar"
          variant="success"
          class="fr ml-4 px-4"
          @click="onSearch"
        />
        <action-button
          v-if="!simple"
          i="fal fa-sliders-v"
          variant="orange"
          class="fr mr-2 pl-3"
          :class="{ transparent: !isAdvancedFilter }"
          @click="onPressAdvancedFilter"
        />
      </div>
    </div>

    <div v-if="!simple && isAdvancedFilter">
      <div class="row py-3">
        <div class="col-12">
          <span class="separator-filter">FILTROS</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pb-2">
          <custom-drop-down-rounded
            placeholder="Filtro"
            :default-value="selectedFilterType"
            :items="availableFilters"
            @on-select-item="onSelectItem"
          />
        </div>
      </div>

      <!-- Standard -->
      <div v-if="selectedFilter.value == searchMode.Standard" class="mb-1">
        <div class="row">
          <div class="col-md-3 col-sm-6">
            <custom-dropdown
              v-model="selectedDiscipline"
              placeholder="Servicio"
              fieldkey="value"
              fieldname="name"
              :default-value="this.defaultValue"
              :options="disciplines"
              :clearable="false"
              label="Servicio"
            />
          </div>

          <div class="col-md-3 col-sm-6">
            <custom-dropdown
              v-model="selectedAdmissionStatus"
              placeholder="Estatus"
              fieldkey="value"
              fieldname="name"
              :options="admissionStatus"
              :default-value="this.defaultValue"
              :clearable="false"
              label="Estatus"
              @input="onSelectedAdmissionStatus"
            />
          </div>
          <div class="col-md-3 col-sm-6 pt-sm-4 pt-md-0">
            <custom-dropdown
              v-model="selectedAdmissionStatusReason"
              placeholder="Razón"
              fieldkey="value"
              fieldname="name"
              :options="admissionStatusReasons"
              :default-value="this.defaultValue"
              :clearable="false"
              :disabled="
                !selectedAdmissionStatus ||
                  (selectedAdmissionStatus && !selectedAdmissionStatus.id)
              "
              label="Razón"
            />
          </div>
          <div class="col-md-3 col-sm-6 pt-sm-4 pt-md-0">
            <custom-dropdown
              v-model="selectedAdmissionReferralType"
              placeholder="Tipo de Referido"
              fieldkey="value"
              fieldname="name"
              :options="admissionReferralTypes"
              :default-value="this.defaultValue"
              :clearable="false"
              label="Tipo de Referido"
            />
          </div>
          <div class="col-md-3 col-sm-6 pt-sm-4 pt-md-0">
            <custom-dropdown
              v-model="selectedServiceModalityType"
              placeholder="Modalidad"
              fieldkey="value"
              fieldname="name"
              :options="serviceModalityTypes"
              :default-value="this.defaultValue"
              :clearable="false"
              label="Modalidad"
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <custom-dropdown
              v-model="selectedCenter"
              placeholder="Centro"
              fieldkey="value"
              fieldname="name"
              :options="centers"
              :default-value="
                centers && centers.length == 1 ? centers[0] : this.defaultValue
              "
              :disabled="centers && centers.length == 1"
              :clearable="false"
              label="Centro"
              @input="onSelectedCenter"
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <custom-dropdown
              v-model="selectedMunicipality"
              placeholder="Municipio"
              fieldkey="value"
              fieldname="name"
              :options="municipalities"
              :default-value="
                municipalities && municipalities.length == 1
                  ? municipalities[0]
                  : this.defaultValue
              "
              :disabled="
                (municipalities && municipalities.length <= 1) ||
                  !selectedCenter ||
                  (selectedCenter && !selectedCenter.id)
              "
              :clearable="false"
              label="Municipio"
              @input="onSelectedMunicipality"
            />
          </div>
          <div class="col-md-3 col-sm-6 pt-sm-4 pt-md-0">
            <custom-dropdown
              v-model="selectedSchool"
              placeholder="Escuela"
              fieldkey="value"
              fieldname="name"
              :options="schools"
              :default-value="this.defaultValue"
              :clearable="false"
              :disabled="
                schools.length <= 1 ||
                  !selectedMunicipality ||
                  (selectedMunicipality && !selectedMunicipality.id)
              "
              label="Escuela"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 pt-sm-4 pt-md-0">
            <custom-dropdown
              v-model="selectedCoordinatedService"
              placeholder="Servicio Coordinado"
              fieldkey="value"
              fieldname="name"
              :options="[
                { value: true, name: 'Sí' },
                { value: false, name: 'No' }
              ]"
              :clearable="true"
              label="Servicio Coordinado"
            />
          </div>
        </div>
      </div>

      <!-- Alert -->
      <div v-if="selectedFilter.value == searchMode.Alert" class="row">
        <div class="col-md-3 col-sm-6">
          <custom-dropdown
            v-model="selectedAlertType"
            placeholder="Alertas"
            fieldkey="value"
            fieldname="name"
            :default-value="this.defaultValue"
            :options="this.alertTypes"
            :clearable="false"
            label="Alertas"
          />
        </div>
        <div class="col-md-3 col-sm-6">
          <custom-dropdown
            v-model="selectedDiscipline"
            placeholder="Servicio"
            fieldkey="value"
            fieldname="name"
            :default-value="this.defaultValue"
            :options="disciplines"
            :clearable="false"
            label="Servicio"
          />
        </div>
        <div class="col-md-3 col-sm-6">
          <custom-dropdown
            v-model="selectedAdmissionStatus"
            placeholder="Estatus"
            fieldkey="value"
            fieldname="name"
            :options="admissionStatus"
            :default-value="this.defaultValue"
            :clearable="false"
            label="Estatus"
            @input="onSelectedAdmissionStatus"
          />
        </div>
      </div>

      <!-- Waiting List -->
      <div v-if="selectedFilter.value == searchMode.WaitList" class="row">
        <div class="col">
          <custom-dropdown
            v-model="selectedCenter"
            placeholder="Centro"
            fieldkey="value"
            fieldname="name"
            :options="centers"
            :clearable="false"
            label="Centro"
          />
        </div>
        <div class="col">
          <custom-dropdown
            v-model="selectedDiscipline"
            placeholder="Servicio"
            fieldkey="value"
            fieldname="name"
            :options="disciplines"
            :clearable="false"
            label="Servicio"
          />
        </div>
      </div>

      <!-- Advance -->
      <div v-if="selectedFilter.value == searchMode.Advanced">
        <div class="row">
          <div class="col-md-3 col-sm-6 col-12">
            <custom-dropdown
              v-model="selectedDiscipline"
              placeholder="Servicio"
              fieldkey="value"
              fieldname="name"
              :default-value="this.defaultValue"
              :options="disciplines"
              :clearable="false"
              label="Servicio"
            />
          </div>
          <div class="col-md-3 col-sm-6 col-12">
            <custom-dropdown
              v-model="selectedAdmissionStatus"
              placeholder="Estatus"
              fieldkey="value"
              fieldname="name"
              :options="admissionStatus"
              :clearable="false"
              label="Estatus"
              @input="onSelectedAdmissionStatus"
            />
          </div>
          <div class="col-md-3 col-sm-6 col-12 pt-sm-4 pt-md-0">
            <custom-dropdown
              v-model="selectedAdmissionStatusReason"
              placeholder="Razón"
              fieldkey="value"
              fieldname="name"
              :disabled="
                !selectedAdmissionStatus ||
                  (selectedAdmissionStatus && !selectedAdmissionStatus.id)
              "
              :options="admissionStatusReasons"
              :default-value="this.defaultValue"
              :clearable="false"
              label="Razón"
            />
          </div>
          <div class="col-md-3 col-sm-6 col-12 pt-sm-4 pt-md-0">
            <custom-dropdown
              v-model="selectedAdmissionReferralType"
              placeholder="Tipo de Referido"
              fieldkey="value"
              fieldname="name"
              :options="admissionReferralTypes"
              :clearable="false"
              label="Tipo de Referido"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-12 pt-4">
            <custom-dropdown
              v-model="selectedProvider"
              placeholder="Proveedor"
              fieldkey="value"
              fieldname="name"
              :options="this.providers"
              :default-value="this.defaultValue"
              :clearable="false"
              label="Proveedor"
              @input="onSelectedProvider"
            />
          </div>
          <div class="col-md-3 col-sm-6 col-12 pt-4">
            <custom-dropdown
              v-model="selectedCenter"
              placeholder="Centro"
              fieldkey="id"
              fieldname="name"
              :options="centers"
              :default-value="
                centers.length == 1 ? centers[0] : this.defaultValue
              "
              :disabled="!this.isFiltering || centers.length == 1"
              :clearable="false"
              label="Centro"
              @input="onSelectedCenter"
            />
          </div>

          <div class="col-md-3 col-sm-6 col-12 pt-4">
            <custom-dropdown
              v-model="selectedMunicipality"
              placeholder="Municipio"
              fieldkey="value"
              fieldname="name"
              :options="municipalities"
              :default-value="this.defaultValue"
              :clearable="false"
              :disabled="!this.isFiltering"
              label="Municipio"
              @input="onSelectedMunicipality"
            />
          </div>
          <div class="col-md-3 col-sm-6 col-12 pt-4">
            <custom-dropdown
              v-model="selectedLocationType"
              placeholder="Tipo de Lugar"
              fieldkey="value"
              fieldname="name"
              :options="locationTypes"
              :default-value="this.defaultValue"
              :disabled="!this.isFiltering"
              :clearable="false"
              label="Tipo de Lugar"
              @input="onSelectedLocationType"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-12 pt-4">
            <custom-dropdown
              v-model="selectedLocationService"
              placeholder="Lugar"
              fieldkey="value"
              fieldname="name"
              :options="locationServices"
              :default-value="this.defaultValue"
              :disabled="!this.isFiltering"
              :clearable="false"
              label="Lugar"
              @input="onSelectedLocationService"
            />
          </div>
          <div class="col-md-3 col-sm-6 col-12 pt-4">
            <custom-dropdown
              v-model="selectedSpecialist"
              placeholder="Especialista"
              fieldkey="value"
              fieldname="name"
              :options="specialists"
              :disabled="!this.isFiltering"
              :default-value="this.defaultValue"
              :clearable="false"
              label="Especialista"
            />
          </div>
        </div>
      </div>

      <!-- Other Services -->
      <div v-if="selectedFilter.value == searchMode.Others" class="mb-1">
        <div class="row">
          <div class="col-md-6 col-12">
            <custom-dropdown
              v-model="selectedCenter"
              placeholder="Centro"
              fieldkey="value"
              fieldname="name"
              :options="centers"
              :default-value="
                centers && centers.length == 1 ? centers[0] : this.defaultValue
              "
              :disabled="centers && centers.length == 1"
              :clearable="false"
              label="Centro:"
            />
          </div>

          <div class="col-md-6 col-12">
            <custom-dropdown
              v-model="selectedTransportation"
              placeholder="Transportación"
              fieldkey="id"
              fieldname="name"
              :options="transportations"
              :default-value="
                transportations && transportations.length == 1
                  ? transportations[0]
                  : this.defaultValue
              "
              :clearable="false"
              label="Transportación:"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import peiService from "@/services/pei/general.js";
import { createNamespacedHelpers } from "vuex";
import CustomDropdown from "@/components/common/CustomDropDown";
import CustomInput from "@/components/common/CustomInput";
import ActionButton from "@/components/common/ActionButton";
import SearchMode from "@/utils/constants/pei/referral/searchMode";
import RadioBtnGroup from "@/components/pei/ref/RadioBtnGroup";
import CustomDropDownRounded from "@/components/common/CustomDropDownRounded";
import ThrpyReferralAlertTypes from "@/utils/constants/pei/referral/thrpyReferralAlertTypes";
import { modulesName } from "@/modules";
const {
  mapState,
  mapMutations,
  mapActions,
  mapGetters
} = createNamespacedHelpers(modulesName.referralModuleName);
import * as referralTypes from "@/modules/referral/store/types.js";

export default {
  name: "ReferralFilter",
  components: {
    CustomDropdown,
    CustomInput,
    ActionButton,
    RadioBtnGroup,
    CustomDropDownRounded
  },
  props: {
    simple: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    searchMode: SearchMode,

    //This default value is for dropdown
    defaultValue: {
      id: null,
      name: "Todos",
      selected: "true"
    },
    //Basic
    selectedAcademicYear: null,
    isAdvancedFilter: false,
    searchText: "",
    selectedFilter: 0,
    radioBtnSelected: {},
    selectedFilterType: 1,

    //Standard
    selectedSchool: {},
    selectedCoordinatedService: {},
    selectedServiceModalityType: {},
    //Standard & Advanced Mode
    selectedMunicipality: {},
    selectedAdmissionReferralType: {},
    selectedAdmissionStatus: {},
    selectedAdmissionStatusReason: {},

    // Advanced Mode
    isFiltering: false, //advanced filters bussiness logic selected (Provider depends)
    //advanced filters bussiness logic selected (Service, Status, Reason, ReferralType)
    isReferralFiltering: false,
    selectedMonth: {},
    selectedProvider: {},
    selectedLocationType: {},
    selectedLocationService: {},
    selectedSpecialist: {},

    //Advanced & Waiting List Mode Filters
    selectedDiscipline: {},
    selectedCenter: {},

    //Alerts
    selectedAlertType: {},
    alertTypes: [
      {
        id: 0,
        name:
          "Estudiantes con Estatus Egresados y Referidos desde el estatus de vinculado"
      },
      { id: 1, name: "Estatus de Vinculaciones Iniciales" },

      {
        id: 2,
        name: "Referidos con cambios de Definición de Servicios"
      },
      { id: 3, name: "Vencimiento de Admisión" },
      { id: 4, name: "Vencimiento de Servicio" }
    ],

    //Others
    transportations: [],
    selectedTransportation: {}
  }),
  watch: {
    academicyears() {
      if (this.selectedAcademicYear == null && this.academicyears?.length > 0) {
        this.setCurrentAcademicYear();
      }
    },
    /**
     * Posible refactory (Crear una entidad que tenga los selected)
     * */
    selectedProvider() {
      this.onFiltering();
    },
    selectedDiscipline() {
      //Student
      this.onFiltering();
    },
    selectedAdmissionStatus() {
      this.onFiltering();
    },
    selectedAdmissionReferralType() {
      this.onFiltering();
    },
    centers(value) {
      if (value?.length === 1 && this.selectedProvider != this.defaultValue)
        this.selectedCenter = value[0];
    }
  },
  computed: {
    ...mapState({
      academicyears: state => state.referral.filters.academicyears,
      disciplines: state => state.referral.filters.disciplines,
      centers: state => state.referral.filters.centers,
      municipalities: state => state.referral.filters.municipalities,
      schools: state => state.referral.filters.schools,
      admissionStatusReasons: state =>
        state.referral.filters.admissionStatusReasons,
      admissionStatus: state => state.referral.filters.admissionStatus,
      admissionReferralTypes: state =>
        state.referral.filters.admissionReferralTypes,
      serviceModalityTypes: state =>
        state.referral.filters.serviceModalityTypes,
      months: state => state.referral.filters.months,
      providers: state => state.referral.filters.providers,
      specialists: state => state.referral.filters.specialists,
      locationServices: state => state.referral.filters.locationServices,
      locationTypes: state => state.referral.filters.locationTypes
    }),
    ...mapGetters(["filters"]), //This getter valid if the user have permission to see waiting list
    searchTextPlaceholder() {
      let searchText = "Escriba Número de SIE o Número de Referido";
      if (
        this.selectedFilter &&
        this.selectedFilter.value == this.searchMode.WaitList
      ) {
        searchText = "Escriba Número de SIE";
      }
      return searchText;
    },
    hasCenterAccessLevel() {
      return true; //this.$store.getters.HasPermission("level.center");
    },
    hasSchoolAccessLevel() {
      return true; // this.$store.getters.HasPermission("level.school");
    },
    hasMunicipalyAccessLevel() {
      return true; // this.$store.getters.HasPermission("level.municipality");
    },
    specialistId() {
      const specialistId = this.$store.state.userProfile.specialistId ?? 0;
      return parseInt(specialistId);
    },
    availableFilters() {
      const hasPermission = this.userHasPermissions(
        "student.referrals.viewotherservicesoption"
      );
      const items =
        this.specialistId > 0
          ? this.filters.filter(x => x.id !== 3)
          : this.filters;
      return hasPermission
        ? items
        : items.filter(x => x.id !== SearchMode.Others);
    },
    selectedYearId() {
      const { currentFilters } = this.$store.state[
        modulesName.referralModuleName
      ].referral.filters;
      const id =
        this.selectedAcademicYear?.id ??
        currentFilters.selectedAcademicYear?.id;

      return id;
    },
    hasSelectedYear() {
      return this.selectedYearId > 0;
    }
  },
  methods: {
    async getTypes() {
      const { data } = await peiService.getPeiCodeTypes("PeiTransportation");
      this.transportations = data;
    },
    onFiltering() {
      if (
        this.selectedDiscipline.id != null ||
        this.selectedAdmissionStatus.id != null ||
        this.selectedAdmissionReferralType.id != null ||
        this.selectedAdmissionStatusReason.id != null
      ) {
        this.isReferralFiltering = true;
      } else {
        this.isReferralFiltering = false;
      }

      if (
        this.selectedLocationType.id != null ||
        this.selectedLocationService.id != null ||
        this.selectedSpecialist.id != null ||
        this.selectedMunicipality.id != null ||
        this.selectedCenter.id != null ||
        this.selectedSchool.id != null ||
        this.selectedCoordinatedService.id != null ||
        this.selectedProvider.id != null
      ) {
        this.isFiltering = true;
      } else {
        this.isFiltering = false;
      }
    },
    ...mapMutations([
      referralTypes.MUTATION_TYPES.SET_REFERRAL_MUNICIPALITIES,
      referralTypes.MUTATION_TYPES.SET_REFERRAL_CENTERS,
      referralTypes.MUTATION_TYPES.SET_CURRENT_FILTERS,
      referralTypes.SET_CLEAR_FILTERS
    ]),
    ...mapActions([
      referralTypes.ACTION_TYPES.GET_FILTERS,
      referralTypes.ACTION_TYPES.GET_FILTERS_BY_STATUS,
      referralTypes.ACTION_TYPES.GET_FILTERS_BY_PROVIDER,
      referralTypes.ACTION_TYPES.GET_FILTERS_BY_CENTER,
      referralTypes.ACTION_TYPES.GET_FILTERS_BY_MUNICIPALITY,
      referralTypes.ACTION_TYPES.GET_FILTERS_BY_LOCATION_TYPE,
      referralTypes.ACTION_TYPES.GET_FILTERS_BY_LOCATION_SERVICE
    ]),
    onRadioBtnChange(value) {
      this.radioBtnSelected = value;
    },
    onSelectItem(filter) {
      //Valid if filter type is different
      if (filter.id != this.selectedFilterType) {
        this.selectedFilterType = filter.id;
        this.selectedFilter = filter;
        //Get All Filters only for advance option
        const payload = {
          searchMode: filter.value,
          academicYearId: this.selectedAcademicYear.id
        };
        this.getFilters(payload);
        this.onClearSelectionFilter();
        //Set Centers changes
        if (
          this.centers?.length == 1 &&
          this.selectedProvider != this.defaultValue
        ) {
          this.onSelectedCenter();
        }
      }
    },
    onClearSelectionFilter() {
      //General
      this.selectedDiscipline = this.defaultValue;
      this.selectedMunicipality = this.defaultValue;
      this.selectedSchool = this.defaultValue;
      this.selectedCoordinatedService = this.defaultValue;
      this.selectedAdmissionStatusReason = this.defaultValue;
      this.selectedAdmissionStatus = this.defaultValue;
      this.selectedAdmissionReferralType = this.defaultValue;
      this.selectedServiceModalityType = this.defaultValue;
      //Advanced
      this.selectedMonth = null;
      this.selectedProvider = this.defaultValue;
      this.selectedLocationType = this.defaultValue;
      this.selectedLocationService = this.defaultValue;
      this.selectedSpecialist = this.defaultValue;

      //Advanced & Waiting List
      if (
        this.centers &&
        this.centers.length == 1 &&
        this.selectedProvider != this.defaultValue
      ) {
        this.selectedCenter = this.centers[0];
      } else {
        this.selectedCenter = this.defaultValue;
      }
      this.selectedAlertType = null;
      //Other Services
      this.selectedTransportation = this.defaultValue;

      //
      this.onClearFilters({
        municipalities: [],
        schools: []
      });
    },
    onSearch() {
      let model = {
        academicYear: this.selectedAcademicYear.id,
        discipline: this.selectedDiscipline ? this.selectedDiscipline.id : null,
        statusId: this.selectedStatus ? this.selectedStatus.id : null,
        center: this.selectedCenter ? this.selectedCenter.id : null,
        municipality: this.selectedMunicipality?.id,
        school: this.selectedSchool?.id,
        admissionStatusReason: this.selectedAdmissionStatusReason?.id,
        admissionStatus: this.selectedAdmissionStatus?.id,
        admissionReferralType: this.selectedAdmissionReferralType?.id,
        modalityTypeId: this.selectedServiceModalityType?.id,
        searchMode: this.selectedFilter ? this.selectedFilter.value : 0,
        searchText: this.searchText,
        thrpyReferralAlertTypes: !this.selectedAlertType
          ? ThrpyReferralAlertTypes.unSet
          : this.selectedAlertType?.id,
        //Advanced Options
        month: this.selectedMonth == null ? null : this.selectedMonth.id,
        providerId: this.selectedProvider?.id,
        locationTypeId: this.selectedLocationType?.id,
        locationServiceId: this.selectedLocationService?.id,
        specialistId: this.selectedSpecialist?.id,
        coordinatedService: this.selectedCoordinatedService?.value,
        transportTypeId:this.selectedTransportation?.id
      };
      //Call Store Mutation for persisted
      this.setCurrentFilters({
        //Basic
        selectedAcademicYear: this.selectedAcademicYear,
        isAdvancedFilter: this.isAdvancedFilter,
        searchText: this.searchText,
        selectedFilter: this.selectedFilter,
        radioBtnSelected: this.radioBtnSelected,
        selectedFilterType: this.selectedFilterType,

        //Standard
        selectedSchool: this.selectedSchool,
        selectedServiceModalityType: this.selectedServiceModalityType,
        selectedCoordinatedService: this.selectedCoordinatedService,
        //Standard & Advanced Mode
        selectedDiscipline: this.selectedDiscipline,
        selectedMunicipality: this.selectedMunicipality,
        selectedAdmissionReferralType: this.selectedAdmissionReferralType,
        selectedAdmissionStatus: this.selectedAdmissionStatus,
        selectedAdmissionStatusReason: this.selectedAdmissionStatusReason,

        //Advanced
        selectedMonth: this.selectedMonth,
        selectedProvider: this.selectedProvider,
        selectedLocationType: this.selectedLocationType,
        selectedLocationService: this.selectedLocationService,

        //Advanced & Waiting List
        selectedSpecialist: this.selectedSpecialist,
        selectedCenter: this.selectedCenter,

        //Other Services
        selectedTransportation: this.selectedTransportation,

        //Alert
        selectedAlertType: this.selectedAlertType
      });

      // Only validate if advanced mode and don't selected any filter
      if (
        this.selectedFilter.value == this.searchMode.Advanced &&
        !this.isFiltering &&
        !this.isReferralFiltering
      ) {
        this.$refs.months.validate();
        if (this.selectedMonth == null) {
          return;
        }
      }
      //Emit for Search
      this.$emit("onSearch", model, true);
    },
    async onPressAdvancedFilter() {
      this.isAdvancedFilter = !this.isAdvancedFilter;
      this.selectedFilterType = 1;
      this.selectedFilter = this.filters[0];
      this.onClearSelectionFilter();

      if (!this.hasSelectedYear) {
        this.setCurrentAcademicYear();
      }

      if (this.isAdvancedFilter && this.hasSelectedYear) {
        await this.getFilters({
          searchMode: this.selectedFilter.value,
          academicYearId: this.selectedYearId
        });
        //Set Default Values

        if (
          this.centers.length == 1 &&
          this.selectedProvider == this.defaultValue
        ) {
          //Search Municipalities
          this.selectedCenter = this.centers[0];
          this.onSelectedCenter();
        }
      }
    },

    async resetFilters() {
      this.onClearSelectionFilter();
      const selectedFilter = this.filters.filter(
        f => f.id == this.selectedFilterType
      )[0];
      //Validate if advaced filter is selected to load only the filters requireds
      const selectedSearchMode = this.isAdvancedFilter
        ? selectedFilter.value
        : SearchMode.Basic;
      this.getFilters({
        searchMode: selectedSearchMode,
        academicYearId: this.selectedAcademicYear.id
      });
      await this.onSelectedProvider();
      this.selectedCenter = this.defaultValue;
    },
    //OnChanges Events
    async onSelectedAdmissionStatus() {
      this.selectedAdmissionStatusReason = this.defaultValue;
      this.getFiltersByStatus({
        searchMode: this.selectedFilter.value,
        statusId: this.selectedAdmissionStatus.id
      });
    },
    async onSelectedProvider() {
      const selectedFilter = this.filters.filter(
        f => f.id == this.selectedFilterType
      )[0];
      const payload = {
        searchMode: selectedFilter.value,
        academicYearId: this.selectedAcademicYear.id,
        providerId: this.selectedProvider.id,
        centerId: this.selectedCenter.id
      };
      //Clear Selected
      this.selectedSpecialist = this.defaultValue;
      this.selectedLocationService = this.defaultValue;
      this.selectedMunicipality = this.defaultValue;
      this.selectedCenter = this.defaultValue;

      await this.getFiltersByProvider(payload);

      //Default Selection
      if (
        this.centers?.length == 1 &&
        this.selectedProvider != this.defaultValue
      ) {
        this.selectedCenter = this.centers[0];
      }
    },
    async onSelectedCenter() {
      const selectedFilter = this.filters.filter(
        f => f.id == this.selectedFilterType
      )[0];
      const payload = {
        searchMode: selectedFilter.value,
        academicYearId: this.selectedAcademicYear.id,
        providerId: this.selectedProvider.id,
        centerId: this.selectedCenter.id
      };
      this.selectedSpecialist = this.defaultValue;
      this.selectedLocationService = this.defaultValue;
      this.selectedMunicipality = this.defaultValue;
      this.selectedSchool = this.defaultValue;
      this.selectedCoordinatedService = this.defaultValue;

      this.onClearFilters({
        municipalities: [],
        schools: []
      });

      await this.getFiltersByCenter(payload);

      //Set municipality changes
      if (this.municipalities?.length === 1) {
        this.selectedMunicipality = this.municipalities[0];
        this.onSelectedMunicipality();
      }
    },
    async onSelectedMunicipality() {
      const selectedFilter = this.filters.filter(
        f => f.id == this.selectedFilterType
      )[0];
      const payload = {
        searchMode: selectedFilter.value,
        academicYearId: this.selectedAcademicYear.id,
        providerId: this.selectedProvider.id,
        centerId: this.selectedCenter.id,
        municipalityId: this.selectedMunicipality.id
      };
      this.selectedSpecialist = this.defaultValue;
      this.selectedSchool = this.defaultValue;
      this.selectedCoordinatedService = this.defaultValue;
      this.selectedLocationService = this.defaultValue;
      await this.getFiltersByMunicipality(payload);

      //Set school changes
      if (this.schools?.length === 1) {
        this.selectedSchool = this.schools[0];
      }
    },
    onSelectedLocationType() {
      const selectedFilter = this.filters.filter(
        f => f.id == this.selectedFilterType
      )[0];
      const payload = {
        searchMode: selectedFilter.value,
        academicYearId: this.selectedAcademicYear.id,
        providerId: this.selectedProvider.id,
        centerId: this.selectedCenter.id,
        municipalityId: this.selectedMunicipality.id,
        locationTypeId: this.selectedLocationType.id
      };
      //Clear
      this.selectedSpecialist = this.defaultValue;
      this.selectedLocationService = this.defaultValue;
      this.getFiltersByLocationType(payload);
    },
    onSelectedLocationService() {
      const selectedFilter = this.filters.filter(
        f => f.id == this.selectedFilterType
      )[0];
      const payload = {
        searchMode: selectedFilter.value,
        academicYearId: this.selectedAcademicYear.id,
        providerId: this.selectedProvider.id,
        centerId: this.selectedCenter.id,
        municipalityId: this.selectedMunicipality.id,
        locationTypeId: this.selectedLocationType.id,
        locationServiceId: this.selectedLocationService.id
      };
      this.getFiltersByLocationService(payload);
    },
    onClearFilters(filters) {
      this[referralTypes.SET_CLEAR_FILTERS](filters);
    },
    setCurrentAcademicYear() {
      const currentAcademicYear = this.academicyears.find(
        f =>
          f.id ==
          this.$store.state[modulesName.commonModuleName].currentAcademicYear.id
      );
      this.selectedAcademicYear = currentAcademicYear;
    }
  },
  //Life Cycle
  async mounted() {
    if (
      this.$store.state[modulesName.referralModuleName].referral.results
        .length != 0
    ) {
      //call persited data
      const { currentFilters } = this.$store.state[
        modulesName.referralModuleName
      ].referral.filters;

      this.selectedAcademicYear = currentFilters.selectedAcademicYear;
      this.isAdvancedFilter = currentFilters.isAdvancedFilter;

      this.searchText = currentFilters.searchText;
      this.selectedFilter = currentFilters.selectedFilter;
      this.radioBtnSelected = currentFilters.radioBtnSelected;
      this.selectedFilterType = currentFilters.selectedFilterType;

      this.selectedDiscipline = currentFilters.selectedDiscipline;
      this.selectedMonth = currentFilters.selectedMonth;
      this.selectedProvider = currentFilters.selectedProvider;
      this.selectedLocationType = currentFilters.selectedLocationType;
      this.selectedLocationService = currentFilters.selectedLocationService;
      this.selectedSpecialist = currentFilters.selectedSpecialist;

      //Standard
      this.selectedSchool = currentFilters.selectedSchool;
      this.selectedCoordinatedService =
        currentFilters.selectedCoordinatedService;
      this.selectedServiceModalityType =
        currentFilters.selectedServiceModalityType;
      //Standard & Advanced Mode
      this.selectedMunicipality = currentFilters.selectedMunicipality;
      this.selectedAdmissionReferralType =
        currentFilters.selectedAdmissionReferralType;
      this.selectedAdmissionStatus = currentFilters.selectedAdmissionStatus;
      this.selectedAdmissionStatusReason =
        currentFilters.selectedAdmissionStatusReason;
      this.selectedCenter = currentFilters.selectedCenter;
      //other services
      this.selectedTransportation =currentFilters.selectedTransportation

      //Alert
      this.selectedAlertType = currentFilters.selectedAlertType;
    }
    await this.getTypes();
  }
};
</script>

<style>
.filter-container {
  background-color: #f4f6f3;
  padding: 23px 27px 20px 30px;
}
.separator-filter {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 500 14px/17px Lato;
}
.separator-filter::before,
.separator-filter::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator-filter::before {
  margin-right: 0.5em;
}
.separator-filter::after {
  margin-left: 0.5em;
}
.custom-ddl {
  color: #495057;
  line-height: 1.6;
}
span.vs__selected {
  color: #495057;

  opacity: 0.8;
  line-height: 1.6;
  z-index: 1;
}
div.custom-ddl label.input-label {
  text-align: left;
  font-size: 14px !important;
  font-weight: 200;
  letter-spacing: 0px;
  color: #727272 !important;
  opacity: 1;
  z-index: 1;
}
</style>
